import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const Pagination = ({ page, totalPages, onChange }) => {
  if (totalPages <= 1) return null;

  // Compute pages to show: current ± 2, first, last, ellipsis
  const buildPages = () => {
    const pages = new Set([1, totalPages]);
    for (let p = Math.max(1, page - 2); p <= Math.min(totalPages, page + 2); p++) {
      pages.add(p);
    }
    return Array.from(pages).sort((a, b) => a - b);
  };

  const pages = buildPages();
  const goPrev = () => onChange(Math.max(1, page - 1));
  const goNext = () => onChange(Math.min(totalPages, page + 1));

  return (
    <nav
      data-testid="catalog-pagination"
      aria-label="Pagination"
      className="flex items-center justify-center gap-2 mt-10 flex-wrap"
    >
      <button
        data-testid="page-prev"
        onClick={goPrev}
        disabled={page === 1}
        className="cartoon-btn bg-white hover:bg-yellow-200 py-2 px-3 text-sm disabled:opacity-40 disabled:cursor-not-allowed"
        aria-label="Previous page"
      >
        <ChevronLeft className="w-4 h-4" strokeWidth={3} />
        <span className="hidden sm:inline">Indietro</span>
      </button>

      <div className="flex items-center gap-1">
        {pages.map((p, idx) => {
          const prev = pages[idx - 1];
          const showGap = prev && p - prev > 1;
          return (
            <React.Fragment key={p}>
              {showGap && (
                <span className="px-2 text-slate-500 font-bold" aria-hidden="true">
                  …
                </span>
              )}
              <button
                data-testid={`page-${p}`}
                onClick={() => onChange(p)}
                aria-current={p === page ? "page" : undefined}
                className={`min-w-[40px] h-10 px-2 border-4 border-slate-900 rounded-full font-bold text-sm cartoon-shadow-sm transition-all ${
                  p === page
                    ? "bg-pink-400 text-slate-900"
                    : "bg-white hover:bg-yellow-200 text-slate-900"
                }`}
              >
                {p}
              </button>
            </React.Fragment>
          );
        })}
      </div>

      <button
        data-testid="page-next"
        onClick={goNext}
        disabled={page === totalPages}
        className="cartoon-btn bg-white hover:bg-yellow-200 py-2 px-3 text-sm disabled:opacity-40 disabled:cursor-not-allowed"
        aria-label="Next page"
      >
        <span className="hidden sm:inline">Avanti</span>
        <ChevronRight className="w-4 h-4" strokeWidth={3} />
      </button>
    </nav>
  );
};

export default Pagination;
